/**
 * These tokens are for dependency injection in a child container.
 * They should only be used within a module's child container, not
 * the global tsyringe container.
 */
import { InjectionToken } from "tsyringe";

import ApplyDiscountAvailabilityProvider from "./ApplyDiscountAvailabilityProvider/ApplyDiscountAvailabilityProvider";
import CartAvailabilityProvider from "./CartAvailabilityProvider/CartAvailabilityProvider";
import { PathPrefixProvider } from "./PathPrefixProvider/PathPrefixProvider";
import ReferrerProvider from "./ReferrerProvider/ReferrerProvider";

export const applyDiscountAvailabilityProviderToken = Symbol(
    "applyDiscountAvailabilityProvider"
) as InjectionToken<ApplyDiscountAvailabilityProvider>;

export const cartAvailabilityProviderToken = Symbol(
    "cartAvailabilityProvider"
) as InjectionToken<CartAvailabilityProvider>;

export const referrerProviderToken = Symbol(
    "referrerProvider"
) as InjectionToken<ReferrerProvider>;

export const pathPrefixProviderToken = Symbol(
    "pathPrefixProvider"
) as InjectionToken<PathPrefixProvider>;
